import { useMemo } from 'react';

import { useDealContext } from '../../utils/context/DealContext';

type UseGetDealSourceName = {
  dealSourceId?: string;
};

export const useGetDealSourceName = ({ dealSourceId }: UseGetDealSourceName) => {
  const { useDealSourceFetch } = useDealContext();

  const { dealSourceOptionsList } = useDealSourceFetch();

  const dealSourceValue = useMemo(
    () => dealSourceOptionsList?.find(option => option.id === dealSourceId)?.name ?? dealSourceId,
    [dealSourceOptionsList, dealSourceId]
  );

  return { dealSourceValue };
};
